import { BaseService, Service } from "/@/cool";
@Service("repairGroupRejectSetting")
class RepairGroupRejectSetting extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}
		this.permission["page"] = prefix + "page";
		this.permission["list"] = prefix + "list";
		this.permission["info"] = prefix + "info";
		this.permission["add"] = prefix + "add";
		this.permission["update"] = prefix + "update";
		this.permission["delete"] = prefix + "delete";
		this.permission["save"] = prefix + "save";
	}

	save(data: any) {
		return this.request({
			url: "/save",
			method: "POST",
			data
		});
	}
	settingItem(data: any) {
		return this.request({
			url: "/settingItem",
			method: "POST",
			data
		});
	}

}
export default RepairGroupRejectSetting;
